import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const ahoiCustomerGroup = 'ahoi';
export const customerGroup = ahoiCustomerGroup;
const supportEmail = {
	ahoi: 'ahoi@smoothr.de',
};
const firebaseConfig = {
	ahoi: {
		apiKey: 'AIzaSyBbGBlbK3Xy5zg8RNWnVGTu9YM57B9XnCU',
		authDomain: 'ahoi-2d14b.firebaseapp.com',
		projectId: 'ahoi-2d14b',
		storageBucket: 'ahoi-2d14b.firebasestorage.app',
		messagingSenderId: '20804175012',
		appId: '1:20804175012:web:47e09d14e5a6f77dca5231',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['ch'],
	gaId: '',
	hasRecommendations: true,
	apiUrl: 'https://dev-dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
};

import 'zone.js';
